var Player = require("./classes/Player.js");

module.exports = {
  Player: Player
};